import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InfoBoxComponent } from '../info-box/info-box.component';

@Component({
  selector: 'app-control-label',
  imports: [InfoBoxComponent],
  templateUrl: './control-label.component.html',
  styleUrl: './control-label.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ControlLabelComponent {
  control = input.required<AbstractControl | null>();
  caption = input.required<string>();
  infoText = input<string>('');
  forId = input<string | null>(null);

  protected readonly infoBoxVisible = signal(false);

  toggleInfoBox() {
    this.infoBoxVisible.update((visible) => !visible);
  }

  get isRequired(): boolean {
    if (!this.control()?.validator) {
      return false;
    }
    const validator = this.control()?.validator({} as AbstractControl);
    return (validator?.required as boolean) ?? false;
  }

  get isEnabled(): boolean {
    return this.control()?.status !== 'DISABLED';
  }
}